module.exports = __webpack_public_path__ + "img/activity-logs-active.444c6a4.svg";